import React from 'react'
import './TaskViews.scss'

interface TaskTodayViewProps {
  lifeSpace?: 'personal' | 'work' | 'home' | 'all'
}

export const TaskTodayView: React.FC<TaskTodayViewProps> = () => {
  return (
    <div className="task-view">
      <div className="task-view__header">
        <div className="task-view__title-section">
          <h2 className="task-view__title">Mein Tag</h2>
        </div>
      </div>
    </div>
  )
}
